module.exports = __webpack_public_path__ + "img/暂无估值记录.812d991c.png";